import { Axios, AxiosResponse } from "axios";
import { http, ServerType } from "../http";
import { IAggregationCalcWithHTempReqModel, IAvergeDataReqModel, IGetLocationsReqModel, IOperateFavoriteReqModel } from "./requestType";
import { AverageTemperatureHistogram, ICountriesResModel, IFavoriteModel, IGetLocationsResModel, TemperatureStatResponse } from "./responseType";
import { IFeatureCollectionModel } from "../Lightning/responseType";

const getLocations = async (data: IGetLocationsReqModel) => {
    const url = "/api/ClimateShift/GetLocations";
    const res = await http.post<IGetLocationsReqModel, AxiosResponse<IGetLocationsResModel[]>>(url,
        data,
        ServerType.ServerSimulation,
        true,
        null,
        false
    );
    return res;
};

const AggregationCalcWithHTemp = async (data: IAggregationCalcWithHTempReqModel) => {
    const url = "/api/ClimateShift/AggregationCalculationWithHourlyTemperature";
    const res = await http.post<IAggregationCalcWithHTempReqModel, AxiosResponse<TemperatureStatResponse[]>>(url,
        data,
        ServerType.ServerSimulation,
        true,
        null,
        false
    );
    return res;
};

const isExistsAuthorCode = async (authorCode?: string) => {
    const url = "/api/ClimateShift/IsExistsAuthorCode";
    const res = await http.post<{ authorCode?: string }, AxiosResponse<boolean>>(url,
        {
            authorCode: authorCode
        },
        ServerType.ServerSimulation,
        true,
        null,
        false
    );
    return res;
};

const operateFavorite = async (data: IOperateFavoriteReqModel) => {
    const url = "/api/ClimateShift/OperateFavorite";
    const res = await http.post<IOperateFavoriteReqModel, AxiosResponse<IFavoriteModel[]>>(url,
        data,
        ServerType.ServerSimulation,
        true,
        null,
        false
    );
    return res;
};
const getBoundariesByCountryCode = async (countryCode: string) => {
    const url = "/api/ClimateShift/GetBoundariesByCountryCode";
    const res = await http.post<any, AxiosResponse<IFeatureCollectionModel>>(url,
        {
            countryCode: countryCode
        },
        ServerType.ServerSimulation,
        true,
        null,
        false
    );
    return res;
};

const getCountriesData = async (searchText: string) => {
    const url = "/api/ClimateShift/GetCountries";
    const res = await http.post<any, AxiosResponse<ICountriesResModel[]>>(url,
        {
            searchText: searchText
        },
        ServerType.ServerSimulation,
        true,
        null,
        false
    );
    return res;
};

const getMultipleYearsAverageContours = async (data: IAvergeDataReqModel) => {
    const url = "/api/ClimateShift/MultipleYearsAverageContours";
    const res = await http.post<IAvergeDataReqModel, AxiosResponse<AverageTemperatureHistogram[]>>(url,
        data,
        ServerType.ServerSimulation,
        true,
        null,
        false
    );
    return res;
};

const getLocationsFromServices = async (data: IGetLocationsReqModel) => {
    const url = "/api/ClimateShift/GetLocationFromServices";
    const res = await http.post<IGetLocationsReqModel, AxiosResponse<IGetLocationsResModel[]>>(url,
        data,
        ServerType.ServerSimulation,
        true,
        null,
        false
    );
    return res;
};

export {
    getLocations,
    AggregationCalcWithHTemp,
    isExistsAuthorCode,
    operateFavorite,
    getBoundariesByCountryCode,
    getCountriesData,
    getMultipleYearsAverageContours,
    getLocationsFromServices
};